import { render } from "./factoruma.vue?vue&type=template&id=5cd2ba78&scoped=true"
import script from "./factoruma.vue?vue&type=script&lang=js"
export * from "./factoruma.vue?vue&type=script&lang=js"

import "./factoruma.vue?vue&type=style&index=0&id=5cd2ba78&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd2ba78"]])

export default __exports__